<div class="root">
  <span class="text">{{ text }}</span><a class="text link" [routerLink]="[linkRoute]">{{ linkText }}</a>
</div>
